import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const CustomersPageContent = lazy(() => import("./CustomersPageContent"));

function CustomersPageInternal() {
    return (
        <DefaultPage>
            <CustomersPageContent />
        </DefaultPage>
    );
}

export const CustomersPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(CustomersPageInternal);
